export function commitmentApiBase() {
  return process.env.REACT_APP_API_BASE || "https://api.fmb52.com/api";
}

/**
 * Single Hijri year label from outlet (Layout uses a string; some code uses a legacy array).
 * Never use selectedYear[0] when selectedYear is a string — that is only the first character.
 */
export function normalizeOutletYearString(selectedYear, fallback = "") {
  if (selectedYear == null || selectedYear === "") return fallback;
  if (Array.isArray(selectedYear)) {
    const first = selectedYear[0];
    return first != null && first !== "" ? String(first) : fallback;
  }
  return String(selectedYear);
}

/** Contributions APIs: empty string means “no year filter” on the server when applicable. */
export function yearFromOutletContext(selectedYear) {
  return normalizeOutletYearString(selectedYear, "");
}

/**
 * Mumeneen-style list URLs: string year, or comma-separated legacy array.
 */
export function outletYearForListApi(selectedYear) {
  if (selectedYear == null || selectedYear === "") return "";
  if (Array.isArray(selectedYear)) {
    return selectedYear.length ? selectedYear.map(String).join(",") : "";
  }
  return String(selectedYear);
}
